import type { TransKeys } from '@/i18n/trans/index';
import { createTrans } from '@/i18n/trans/index';
import { Trans } from 'react-i18next';

export const TransAlert = createTrans({
  bookingsSearchFailed: (
    <Trans
      i18nKey="alert.bookingsSearchFailed"
      defaults="Did not find a booking with this email and booking number. Please check the inserted data."
    />
  ),
  consentsNotAgreedWith: (
    <Trans
      i18nKey="alert.consentsNotAgreedWith"
      defaults="You must accept the mandatory consents in order to continue."
    />
  ),
  failedToRetrieveAvailableExtras: (
    <Trans
      i18nKey="alert.failedToRetrieveAvailableExtras"
      defaults="Failed to retrive available extras"
    />
  ),
  failedToSendPasswordResetLink: (
    <Trans
      i18nKey="alert.failedToSendPasswordResetLink"
      defaults="Failed to send password reset link."
    />
  ),
  mandatoryFieldsMustBeFilled: (
    <Trans
      i18nKey="alert.mandatoryFieldsMustBeFilled"
      defaults='All fields must be filled, if not marked as "optional".'
    />
  ),
  mustAgreeWithToC: (
    <Trans
      i18nKey="alert.mustAgreeWithToC"
      defaults="You must agree with terms and conditions to continue."
    />
  ),
  passwordChangeFailed: (
    <Trans
      i18nKey="alert.passwordChangeFailed"
      defaults="Password change failed."
    />
  ),
  passwordResetLinkSentToEmail: (
    <Trans
      i18nKey="alert.passwordResetLinkSentToEmail"
      defaults="Password reset link sent to your email."
    />
  ),
  passwordSuccessfullyChanged: (
    <Trans
      i18nKey="alert.passwordSuccessfullyChanged"
      defaults="Password successfully changed."
    />
  ),
  paymentFailed: (
    <Trans i18nKey="alert.paymentFailed" defaults="Payment failed" />
  ),
  purchaseCancellationFailed: (
    <Trans
      i18nKey="alert.purchaseCancellationFailed"
      defaults="Failed to cancel booking"
    />
  ),
  searchFormValidationFailed: (
    <Trans
      i18nKey="alert.searchFormValidationFailed"
      defaults="We couldn't start your search. Please check your details and try again."
    />
  ),
  voucherApplied: (
    <Trans i18nKey="alert.voucherApplied" defaults="Voucher applied" />
  ),
});

export type TransAlertKeys = TransKeys<typeof TransAlert>;
